<template>
  <footer class="shield-footer">
    <div class="secondary-logo">
      <a href="#" @click.prevent="goToSpartan">
        <img src="../assets/spartan-logo-web_1.svg" alt="Spartan Builders" />
      </a>
      <router-view />
    </div>
  </footer>
</template>

<script>
export default {
  name: "ShieldFooter",
  methods: {
    goToSpartan: function(){
      // console.log('go to shield website');
      window.location.href="http://spartan-builders.com/spartan";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./src/stylesheets/base/_variables.scss";

.shield-footer {
  padding-top: 1em;
  padding-bottom: 0.5em;

  @media screen and (min-width: $medium-bp+0.1) {
    display: flex;
    justify-content: flex-start;
  }

  .secondary-logo {
    @media screen and (max-width: $medium-bp) {
      width: 70%;
      margin: auto;
    }

    @media screen and (min-width: $medium-bp+0.1) {
      width: 25%;
      margin-left: 5%;
    }
  }
}
</style>
